export default "__VITE_ASSET__BKHBOqr8__"